import { createFileRoute } from '@tanstack/react-router';
import { ImportsListRouteView } from '@/pages/workspaces/imports/routing';
import { LastWorkspaceResolver } from './-components';
import { ImportsIndexPage } from './-route-pages';

/**
 * The migrated URL, without the `journeys` segment (FPS-2657).
 *
 * No `appBundle`: the bundle-aware branch of the resolver rebuilds the target from the bundle
 * prefix, which would find no `/journeys/` here and land on the journeys home instead.
 */
function ImportsIndexRoute() {
  return (
    <LastWorkspaceResolver>
      <ImportsListRouteView>
        <ImportsIndexPage />
      </ImportsListRouteView>
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/imports/')({
  component: ImportsIndexRoute,
});
